/* eslint-disable */
import { defineStore } from 'pinia'
import axios from 'axios'

export const useMovieStore = defineStore('movie',
    { state: () => {
        return { 
            movies: [],
            movie:null,
            waiting:true,
            pagination: {
                totalPage: 0,
                nextPage: false,
                prevPage: false,
                currentPage: 1
            },
            pages: []
         }
    },
    actions: {
        fetchData(page = 1, find = ''){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie?page=${page}&find=${find}`)
            .then(response => {
                this.movies = response.data.data
                this.pagination = response.data.pagination
                this.calculatePage()
                this.waiting = false
                console.log(response.data)
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        fetchDataByActorId(page = 1, actorId = 1){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie/movies-by-actor/${actorId}?page=${page}`)
            .then(response => {
                this.movies = response.data.data.map(data => {
                    if(data.movies != undefined && data.movies != null){
                        return data.movies
                    }
                })
                this.pagination = response.data.pagination
                this.calculatePage()
                this.waiting = false
                console.log(response.data.data)
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        fetchDataByGenreId(page = 1, genreId = 1){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie/movies-by-genre/${genreId}?page=${page}`)
            .then(response => {
                this.movies = response.data.data.map(data => {
                    if(data.movies != undefined && data.movies != null){
                        return data.movies
                    }
                })
                this.pagination = response.data.pagination
                this.calculatePage()
                this.waiting = false
                console.log(response.data.data)
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        fetchDataById(id){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie/detail?target=${id}`)
            .then(response => {
                this.movie = response.data.data
                this.waiting = false
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        calculatePage(){
            this.pages = []

            var min = 0
            var max = 0

            var limit = 5

            if(this.pagination.currentPage != 1 && (this.pagination.currentPage % limit) == 0){
                max = this.pagination.currentPage
                min = max - (limit - 1)
            }else if(this.pagination.currentPage == 1){
                min = 1
                max = limit
            }else{
                min = Math.floor(this.pagination.currentPage / limit) * limit
                max = min + limit
                min = min + 1
            }

            for(var x = (min); x <= max; x++){
                if(this.pagination.totalPage >= x){
                    this.pages.push(x)
                }else{
                    break
                }
            }

            console.log(this.pages)
        }
    },getters: {
        getMovies: (state) => state.movies
    }
})